import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { haulerPermissions } from '@ztechapps/totalmilk-hauler.common'
import { useLogoutWhenSignedOut, useUser } from '@ztechapps/common.hook'
import { Spinner } from '@ztechapps/webui.util'
import includes from 'lodash/includes'
import { Sidenav } from './Sidenav'
import { TopBar } from './TopBar'
import { Footer } from './Footer'

const contentSpinner = (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
    <Spinner />
  </div>
)

const MainContent = () => {
  const { user, isActive, hasTenant, loading, logout } = useUser()
  const hasAppAccess = includes(user?.roles, haulerPermissions.canAccess.value)
  const isAuthenticated = hasAppAccess && hasTenant && isActive && !!user?._id

  useLogoutWhenSignedOut({ loading, isAuthenticated, logout })

  if (loading) return contentSpinner

  if (!isAuthenticated) return null

  return (
    <Suspense fallback={contentSpinner}>
      <Outlet context={{ noTopMargin: true }} />
    </Suspense>
  )
}

export const VerticalLayout = () => {
  return (
    <div className="wrapper">
      <Sidenav />
      <TopBar />
      <div className="content-page">
        <MainContent />
        <Footer />
      </div>
    </div>
  )
}
